import { useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";

const useTableConfig = (showSAPColumns, customCaptions) => {
	const { t } = useTranslation();
	const tableConfig = useMemo(() => {
		const headers = [
			customCaptions?.asset || t("entity.asset"),
			t("label.description"),
		];
		const columns = ["assetNumber", "description"];

		if (showSAPColumns) {
			headers.splice(1, 0, customCaptions?.assetReference || t("entity.assetReference"));
			columns.splice(1, 0, "reference");

			headers.push(customCaptions?.assetPlannerGroup || "Planner Group");
			headers.push(customCaptions?.assetMainWorkCenter || "Work Center");
			columns.push("plannerGroup");
			columns.push("workCenter");
		}

		return { headers, columns };
	}, [showSAPColumns, customCaptions, t]);

	const getEditableData = useCallback((row) => {
		return {
			id: row.id,
			assetNumber: row.assetNumber || "",
			reference: row.reference || "",
			description: row.description || "",
			plannerGroup: row.plannerGroup || "",
			workCenter: row.workCenter || "",
		};
	}, []);

	return {
		tableConfig,
		getEditableData,
	};
};

export default useTableConfig;
